import React from 'react';
import { Breadcrumb } from 'antd';
import type { AppBreadcrumbProps } from './types';
import './AppBreadcrumb.css';

export const AppBreadcrumb: React.FC<AppBreadcrumbProps> = ({
  items,
  style
}) => {
  const breadcrumbItems = items.map((item) => {
    const itemClasses = [
      'breadcrumb-item',
      item.isActive ? 'breadcrumb-item--active' : 'breadcrumb-item--default',
      item.onClick ? 'breadcrumb-item--clickable' : ''
    ].filter(Boolean).join(' ');

    return {
      title: (
        <span
          onClick={item.onClick}
          className={itemClasses}
        >
          {item.label}
        </span>
      ),
    };
  });

  return (
    <Breadcrumb
      items={breadcrumbItems}
      separator={
        <span className="breadcrumb-separator">
          /
        </span>
      }
      className="app-breadcrumb"
      style={style}
    />
  );
};
